import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const AgroDescription = () => {
  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}>AGRO </span></p>
      <p className={styles.text}>
        Este un cazan industrial cu schimbător de caldura din țevi pe combustibil solid, cu alimentare manuala. Acest cazan este prevazut sa funcționeze pe baloți de paie cu forma cilindrica dar si dreptunghiulara. Umiditatea baloților de paie nu trebuie sa depășească <b>20% - 25%</b>, acestea fiind bine uscate înainte de a fi balotate timp de câteva zile  înainte. Cele mai bune pentru ardere sunt acelea care au fost uscate dupa câteva ploi si dupa balotate.
      </p>
      <p className={styles.text}>

      </p>
      Cazanul AGRO are o camera de ardere foarte voluminoasă, este prevăzută pentru alimentare cu un balot din paie mare sau câțiva baloți mai mici și arderea acestora.
      Temperatura este controlata de un microprocesor incorporat într-un controller automatizat. Acesta stabilizează temperatura apei prin reducerea și creșterea constanta a numărului de rotații ale ventilatorului ce alimentează cazanul cu aer circular. Partea convexă a cazanului este formată din doua rânduri de tuburi de foc.
      <p className={styles.text}>
        Avantajele de baza ale cazanului sunt : siguranța, eficiența, fiabilitate, economie combustibili, durata de ardere îndelungată după o singura încărcare a combustibilului în cazan.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>150-300</th>
              <th>300-600</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td>kW</td>
              <td>150-300</td>
              <td>300-600</td>
            </tr>
            <tr>
              <td>Combustibil</td>
              <td>-</td>
              <td colSpan="2">Paie, umiditate max 20%</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>22</td>
              <td>58,5</td>
            </tr>
            <tr>
              <td>Randament</td>
              <td>%</td>
              <td colSpan="2">86</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan={"4"}>Dimensiunile camerei de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>1440</td>
              <td>3165</td>
            </tr>
            <tr>
              <td>Diametru</td>
              <td>mm</td>
              <td>1300</td>
              <td>1600</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>1900</td>
              <td>5060</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>m³</td>
              <td>3,1</td>
              <td>5,78</td>
            </tr>
            <tr>
              <td>Greutate cazan, fără apă</td>
              <td>kg</td>
              <td>3000</td>
              <td>7000</td>
            </tr>
            <tr>
              <td>Tiraj necesar ale gazelor arse</td>
              <td>Pa</td>
              <td colSpan="2">60-80</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse la ieșire din cazan</td>
              <td>°C</td>
              <td colSpan="2">100-180</td>
            </tr>
            <tr>
              <td>Temperatura min a apei recomandată</td>
              <td>°C</td>
              <td colSpan="2">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td>°C</td>
              <td colSpan="2">85</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (max admisă)</td>
              <td>mPa</td>
              <td colSpan="2">0,30</td>
            </tr>
            <tr>
              <td>Presiunea experimentată a apei, max</td>
              <td>mPa</td>
              <td colSpan="2">0,50</td>
            </tr>
            <tr>
              <td>Consum curent electric, max</td>
              <td>W</td>
              <td>270</td>
              <td>1500</td>
            </tr>
            <tr>
              <td>Îmbinarea exterioară la coșul de fum</td>
              <td>mm</td>
              <td colSpan="2">298</td>
            </tr>
            <tr>
              <td>Diametrul țevilor rețelei de apă (Du)</td>
              <td>mm</td>
              <td colSpan="2">80 (FL)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div >
  );
};

export const AgroDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [2150, 2600] },
    { param: "B1", unit: "mm", values: [1840, 2310] },
    { param: "H", unit: "mm", values: [2420, 2810] },
    { param: "H1", unit: "mm", values: [2320, 2660] },
    { param: "H2", unit: "mm", values: [2022, 2265] },
    { param: "H3", unit: "mm", values: [380, 465] },
    { param: "L", unit: "mm", values: [2450, 4230] },
    { param: "L1", unit: "mm", values: [1850, 3575] },
    { param: "L2", unit: "mm", values: [340, 385] }
  ]


  const headers = ["Dimensiunile cazanului", "U.M.", "150-300 kW", "300-600 kW"]


  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/AgroSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


